import { render, staticRenderFns } from "./event-details-card-component.vue?vue&type=template&id=d0a2e4d0&scoped=true"
import script from "./event-details-card-component.vue?vue&type=script&lang=js"
export * from "./event-details-card-component.vue?vue&type=script&lang=js"
import style0 from "./event-details-card-component.vue?vue&type=style&index=0&id=d0a2e4d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a2e4d0",
  null
  
)

export default component.exports